import React, {useState, ReactNode} from 'react';
import {I18n} from 'react-redux-i18n';

import {withStyles, WithStyles} from '@material-ui/core';

import {useSelector, useDispatch} from 'react-redux';
import {getUserInfo} from '../../scout-dns/layouts/Operator/action';
import {
  EntityResettingCard,
  RenderOrEmpty,
  SetupTOTPModal,
} from '../../components';
import {Email} from '../../icons';
import MfaSetSVG from './img/MfaSetSVG';
import MfaNotSetSVG from './img/MfaNotSetSVG';

import {style} from './style';
import {SOURCE_2FA_TYPES} from '../../actions/auth/constants';

type TfaStatusRowProps = WithStyles<typeof style> & {
  icon: ReactNode,
  customIconClassname?: string,
  text: String,
  customTextClassname?: string,
};

function TfaStatusRow({
  classes,
  icon,
  customIconClassname = '',
  text,
  customTextClassname = '',
}: TfaStatusRowProps) {
  return (
    <>
      <div className={`${classes.mfaStatusIcon} ${customIconClassname}`}>
        {icon}
      </div>
      <span className={`${customTextClassname}`}>{text}</span>
    </>
  );
}

type TwoFactorAuthStatusProps = WithStyles<typeof style> & {};

function TwoFactorAuthStatus({
  classes,
}: TwoFactorAuthStatusProps) {
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const dispatch = useDispatch();
  const accountInfo = useSelector((store: any) => store.operatorLayoutReducer.accountInfo);

  const handleSuccessfullyResetedTOTP = () => {
    setIsResetModalOpen(false);
    getUserInfo()(dispatch);
  };

  const getMfaStatus = () => {
    if (accountInfo.mfaEnabled !== true || accountInfo.mfaType === SOURCE_2FA_TYPES.NONE) {
      return (
        <TfaStatusRow
          classes={classes}
          customIconClassname={classes.mfaNotSetIcon}
          icon={<MfaNotSetSVG />}
          text={I18n.t('profilePage.mfaBlock.statuses.mfaNotEnabled')}
        />
      );
    }
    if (accountInfo.mfaType === SOURCE_2FA_TYPES.EMAIL) {
      return (
        <TfaStatusRow
          classes={classes}
          customIconClassname={classes.mfaViaEmailIcon}
          icon={<Email />}
          text={I18n.t('profilePage.mfaBlock.statuses.mfaEnabledViaEmail')}
        />
      );
    }
    if (accountInfo.mfaType === SOURCE_2FA_TYPES.TOTP) {
      return (
        <TfaStatusRow
          classes={classes}
          customIconClassname={classes.mfaViaTotpIcon}
          icon={<MfaSetSVG />}
          text={I18n.t('profilePage.mfaBlock.statuses.mfaEnabledViaTOTP')}
        />
      );
    }
  };

  const getIsResetTotpAvailable = () => accountInfo.mfaAllowed &&
    accountInfo.mfaEnabled &&
    accountInfo.mfaType === SOURCE_2FA_TYPES.TOTP &&
    !isResetModalOpen;

  return (
    <>
      <RenderOrEmpty isShow={!!accountInfo.mfaAllowed}>
        <EntityResettingCard
          title={I18n.t('profilePage.mfaBlock.title')}
          entityType={I18n.t('profilePage.mfaBlock.resetButtonLabel')}
          isFullscreen={false}
          content={getMfaStatus()}
          isResetAvailable={getIsResetTotpAvailable()}
          handleClickButtonReset={() => {setIsResetModalOpen(true);}}
        />
      </RenderOrEmpty>
      <SetupTOTPModal
        open={isResetModalOpen}
        onSuccess={handleSuccessfullyResetedTOTP}
      />
    </>
  );
}

export default withStyles(style)(TwoFactorAuthStatus);
